import { useState, useEffect } from 'react';
import axios from 'axios';

const LoadDataNewsActivity = () => {

    const [data, setData] = useState(null);

    const getData = () => {

        axios({
            method: 'get',
            url: `https://script.google.com/macros/s/AKfycbxk_9EQD0GHGbyVUrKfTbmyAE7WcYJp7nH7HrvTSj170C7fcsqbHbi0MCGQtBSz_40f6Q/exec`,
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((res) => {

                if (res.data && res.data) {
                    setData(res.data);
                }

            })
            .catch((error) => {

                console.error('Error fetching data:', error.message);

            })

    }

    useEffect(() => {

        if(!data){
            getData();
        }

    },[data]);

    return data;

}

export default LoadDataNewsActivity